import React from 'react';
import styles from './CriteriaFieldsets.module.scss';
import type { CriteriaFieldsetsLayout } from './CriteriaFieldsets';
import { PICOHelperContent } from 'concepts/Criteria/framework/PICOHelperContent';
import { FRAMEWORK_DEFINITIONS } from 'concepts/Criteria/framework/FrameworkDefinitions';
import {
  CriteriaCategory,
  CriteriaFramework,
} from 'concepts/Criteria/framework/CriteriaFramework';
import {
  Button,
  Icon,
  IconList,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Text,
} from 'components/core';

type Props = {
  label: string;
  criteriaKey: CriteriaCategory;
  requiresFramework: boolean;
  framework?: CriteriaFramework;
  // The sidebar shows bare category labels: no popovers or definitions.
  layout?: CriteriaFieldsetsLayout;
};

const CriteriaSectionHeader = ({
  label,
  criteriaKey,
  requiresFramework,
  framework,
  layout = 'default',
}: Props) => {
  const isSidebar = layout === 'sidebar';
  const learnMoreLabel = `Learn more about ${label}`;
  const HelperContent = PICOHelperContent[criteriaKey];
  const inlineDefinition =
    !isSidebar && requiresFramework && framework
      ? FRAMEWORK_DEFINITIONS[framework]?.[criteriaKey]
      : undefined;

  return (
    <>
      <div className={styles.section}>
        <Text
          // The bare category id is the page's #anchor target - keep global.
          id={criteriaKey}
          size="md"
          component="legend"
          className={styles.legend}
        >
          {label}
        </Text>
        {!isSidebar && !requiresFramework && HelperContent && (
          <Popover closeOnEscape>
            <PopoverTrigger>
              <Button
                htmlType="button"
                variant="ghost"
                type="neutral"
                iconOnly
                aria-label={learnMoreLabel}
                aria-haspopup="dialog"
              >
                <Icon
                  role="presentation"
                  aria-hidden="true"
                  icon={IconList.light.faCircleQuestion}
                />
              </Button>
            </PopoverTrigger>
            <PopoverContent
              className={styles.popoverContent}
              aria-label={learnMoreLabel}
            >
              <div className={styles.popoverContentSpacer}>
                <HelperContent />
              </div>
            </PopoverContent>
          </Popover>
        )}
      </div>
      {inlineDefinition && (
        <Text variant="weak" size="sm" className={styles.definition}>
          {inlineDefinition}
        </Text>
      )}
    </>
  );
};

export default CriteriaSectionHeader;
